import React from 'react';
import { FiX, FiCheck, FiRefreshCw, FiAlertCircle } from 'react-icons/fi';
import styles from '../../../modules/Orders/Orders.module.css';

const formatCurrency = (value) => {
    if (!value && value !== 0) return 'R$ 0,00';
    return `R$ ${Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
};

const ConfirmOrderModal = ({
    order,
    onConfirm,
    onClose,
    isLoading = false,
    title = 'Confirmar Pedido',
    message = 'Ao confirmar este pedido, ele será enviado para aprovação. Não será possível editá-lo após a confirmação.',
    confirmText = 'Confirmar Pedido'
}) => {
    if (!order) return null;

    return (
        <div className={styles.modalBackdrop} onClick={onClose}>
            <div className={`${styles.formContainer} ${styles.formContainerSmall}`} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <div>
                        <h2><FiCheck size={24} style={{ marginRight: '10px', color: '#28a745' }} /> {title}</h2>
                        <p className={styles.modalSubtitle}>Pedido: <strong>{order.code}</strong></p>
                    </div>
                    <button type="button" onClick={onClose} className={styles.modalCloseButton} disabled={isLoading}>
                        <FiX size={24} />
                    </button>
                </div>
                <div className={styles.formContent}>
                    <div className={styles.infoBox}>
                        <FiAlertCircle size={20} />
                        <span>{message}</span>
                    </div>
                    <div className={styles.orderSummary}>
                        <div className={styles.orderSummaryTitle}>Detalhes do Pedido</div>
                        <div className={styles.orderSummaryGrid}>
                            <div className={styles.orderSummaryItem}>
                                <span className={styles.orderSummaryLabel}>Cliente:</span>
                                <span className={styles.orderSummaryValue}>{order.clientName || order.supplierName || '-'}</span>
                            </div>
                            <div className={styles.orderSummaryItem}>
                                <span className={styles.orderSummaryLabel}>Valor Total:</span>
                                <span className={styles.orderSummaryValue}>{formatCurrency(order.calculatedValues?.total)}</span>
                            </div>
                            <div className={styles.orderSummaryItem}>
                                <span className={styles.orderSummaryLabel}>Itens:</span>
                                <span className={styles.orderSummaryValue}>{order.items?.length || 0}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.formActions}>
                    <button type="button" onClick={onClose} className={styles.secondaryButton} disabled={isLoading}>
                        <FiX size={18} /> Cancelar
                    </button>
                    <button type="button" onClick={() => onConfirm(order.id)} className={styles.confirmButton} disabled={isLoading}>
                        {isLoading ? (
                            <><FiRefreshCw size={18} className={styles.buttonSpinner} /> Confirmando...</>
                        ) : (
                            <><FiCheck size={18} /> {confirmText}</>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmOrderModal;